import React from 'react';
import {

  PlayersInner,
  PlayerInner,
  PlayerPair,
  ActionButton

} from './final.js';

class RandomRelationsPrePlayers extends React.Component {
  LABELS = { MEN: "Мужчины", WOMEN: "Девушки" };
  MESSAGES = { MEN: "Из мужчин пока никто не записан", WOMEN: "Из девушек пока никто не записан" };

  label = () => {
    if (this.props.game.isMenLimited) return this.LABELS.MEN;
    if (this.props.game.isWomenLimited) return this.LABELS.WOMEN;
  }

  message = () => {
    if (this.props.game.isMenLimited) return this.MESSAGES.MEN;
    if (this.props.game.isWomenLimited) return this.MESSAGES.WOMEN;
  }

  players = () => {
    if (this.props.game.isMenLimited || this.props.game.isWomenLimited) {
      return (
        <PlayersInner
          label={this.label()}
          message={this.message()}
          players={this.props.game.playersWithoutPayment}
          totalPlayersNum={this.props.game.totalPlayersWithoutPaymentNum}
          playersCount={false}
          flag={""}
        />
      )
    } else {
      return (
        <React.Fragment>
          <PlayersInner
            key={1}
            label={this.LABELS.WOMEN}
            message={this.MESSAGES.WOMEN}
            players={this.props.game.womanPlayersWithoutPayment}
            totalPlayersNum={this.props.game.womanPlayersWithoutPayment.length}
            playersCount={false}
            flag={""}
          />
          <PlayersInner
            key={2}
            label={this.LABELS.MEN}
            message={this.MESSAGES.MEN}
            players={this.props.game.manPlayersWithoutPayment}
            totalPlayersNum={this.props.game.manPlayersWithoutPayment.length}
            playersCount={false}
            flag={""}
          />
        </React.Fragment>
      )
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.players()}
      </React.Fragment>
    )
  }
}

export default RandomRelationsPrePlayers;
